/** WebSocket subprotocol values from OCPP specifications. */
export const OcppSubprotocol = {
  OCPP_1_6: 'ocpp1.6',
  OCPP_2_0_1: 'ocpp2.0.1',
} as const;

export type OcppSubprotocol =
  (typeof OcppSubprotocol)[keyof typeof OcppSubprotocol];

export const OCPP_SUBPROTOCOL_VALUES: OcppSubprotocol[] = [
  OcppSubprotocol.OCPP_1_6,
  OcppSubprotocol.OCPP_2_0_1,
];

export const DEFAULT_OCPP_SUBPROTOCOL = OcppSubprotocol.OCPP_1_6;

export function normalizeOcppSubprotocol(
  value: string | null | undefined,
): OcppSubprotocol {
  if (value === OcppSubprotocol.OCPP_2_0_1) {
    return OcppSubprotocol.OCPP_2_0_1;
  }

  return DEFAULT_OCPP_SUBPROTOCOL;
}

export function isOcpp201Subprotocol(
  value: string | null | undefined,
): boolean {
  return value === OcppSubprotocol.OCPP_2_0_1;
}
